<template>
    <div class="content" ref="content">
        <div class="box-card" shadow="never" :style="{minHeight: Height}">
            <el-row :gutter="20">
                <el-col :span="4" class="left">1</el-col>
                <el-col :span="16" class="center">
                    <p class="question-title">{{examTitle}}</p>
                    <div class="question-list" v-for="(item,i) in questionData" :key="item.qid">
                        <div class="question" v-if="item.questionsTypeId == 100 || item.questionsTypeId == 101 || item.questionsTypeId == 102">
                            <p class="title">{{item.index + 1}}. {{item.questionsName}}
                                <span class="ques-type">
                                    （{{item.questionsTypeId == 100 ? '单选题' : (item.questionsTypeId == 101 ? '多选题' : '判断题')}}）
                                </span>
                            </p>
                            <div class="option-box">
                                <p class="option" v-for="(info, index) in item.optionList" :key="info.oid">{{index + 1}}. {{info.labelName}}</p>
                            </div>
                            <p class="accuracy-box"><span class="accuracy">正确率：{{item.accuracyRate}}%<span class="tips">各项正确率如下：</span></span></p>
                            <el-table
                                :data="item.optionList"
                                border
                                style="width: 100%">
                                <el-table-column label="选项">
                                <template #default='scope'>
                                    {{scope.row.labelName}}
                                    <el-button v-if="scope.row.haveInput" type="text" @click="toOptionInfo(item, scope.row, scope.$index)">查看详情</el-button>
                                    <span class="is-answer" v-if="item.answer.indexOf(scope.row.oid) != -1">（答案）</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="selectedQuantity"
                                label="小计"
                                align="center"
                                width="80">
                                </el-table-column>
                                <el-table-column label="比例">
                                <template #default={row}>
                                    <el-progress :percentage="row.proportion"></el-progress>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="question" v-if="item.questionsTypeId == 204 || item.questionsTypeId == 206">
                            <p class="title">{{item.index + 1}}. {{item.questionsName}}
                                <span class="ques-type">
                                    （{{item.questionsTypeId == 204 ? '填空题' : '简答题'}}）
                                </span>
                            </p>
                            <p class="accuracy-box"><span class="accuracy">正确率：{{item.accuracyRate}}%</span><el-button @click="toInfo(item, i)" size="mini">查看详情</el-button></p>
                        </div>
                        <div class="question" v-if="item.questionsTypeId == 207 || item.questionsTypeId == 208">
                            <p class="title">{{item.index + 1}}. {{item.questionsName}}
                                <span class="ques-type">
                                    （{{item.questionsTypeId == 207 ? '多项填空题' : '横向填空题'}}）
                                </span>
                            </p>
                            <!-- <p class="accuracy-box"><span class="accuracy">正确率：{{item.accuracyRate}}%</span><el-button @click="toInfo(item, i)" size="mini">查看详情</el-button></p> -->
                            <el-table
                                :data="item.optionList"
                                border
                                style="width: 100%">
                                <el-table-column 
                                    prop="labelName" 
                                    label="填空" 
                                    width="150" 
                                    align="center">
                                </el-table-column>
                                <el-table-column label="操作" align="center">
                                    <template #default='scope'>
                                        <el-button type="text" @click="toOptionInfo(item, scope.row, scope.$index)">查看详情</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4" class="right">1
                </el-col>
            </el-row>
        </div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisibleInfo"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%"
            :before-close="beforeCloseInfo">
            <div class="search-box">
                <el-input size="medium" placeholder="请输入内容" v-model="searchValue" class="input-with-select">
                    <el-button slot="append" @click="searchClick" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <el-table
                :data="infoList"
                border
                style="width: 100%">
                <el-table-column
                    prop="name"
                    label="序号"
                    align="center"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="answertime"
                    label="提交答卷时间"
                    align="center"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="answer"
                    label="答案文本">
                </el-table-column>
                <el-table-column 
                    label="操作"
                    align="center"
                    width="80">
                    <template #default={row}>
                        <el-button type="text" @click="viewAnswerSheet(row)">查看答卷</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @current-change="pageChange"
                class="page"
                background
                layout="total,prev, pager, next"
                :total="total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs'
import { mapState } from "vuex";
export default {
    name: 'TopicAccuracy',
    data() {
        return{
            Height: '',
            id: '',
            dialogVisibleInfo: false,
            title: '',
            examTitle: '',
            questionData: [],
            getInfoList: [
                {
                    qid: 'qweqweqweqq',
                    arr: [
                        {
                            name:'123123', // 序号
                            answertime:'123123', // 提交答卷时间
                            answer:'123', // 答案文本
                            underwayId:'123'  //问卷id
                        },
                        {
                            name:'123131',
                            answertime:'123',
                            answer:'123',
                            underwayId:'123'  //问卷id
                        }
                    ]
                },
                {
                    qid: 'weqwewerwtwrq',
                    arr: [
                        {
                            name:'123asdas123',
                            answertime:'12asd3123',
                            answer:'12das3',
                            underwayId:'1ad23'  //问卷id
                        },
                        {
                            name:'123da131',
                            answertime:'12da3',
                            answer:'1a23',
                            underwayId:'12a3'  //问卷id
                        }
                    ]
                },
                {
                    qid: '1242452',
                    arr: [
                        {
                            name:'123123', // 序号
                            answertime:'123123', // 提交答卷时间
                            answer:'123', // 答案文本
                            underwayId:'123'  //问卷id
                        },
                        {
                            name:'123131',
                            answertime:'123',
                            answer:'123',
                            underwayId:'123'  //问卷id
                        }
                    ]
                },
            ],
            infoList: [],
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            searchValue: '',
            qidActive: '',
            oidActive: '',
            questionsTypeId: '',
            haveInputActive: false,
        }
    },
    computed:{
		...mapState(['examQuestionTypeArr']),
	},
    created() {
        this.id = sessionStorage.getItem("examId")
        this.getData()
    },
    mounted() {
        this.Height = `${document.documentElement.clientHeight - 100}px`
    },
    methods:{
        searchClick() {
            console.log(this.searchValue)
            this.getInfoData()
        },
        getData() {
            let that = this
            let data = qs.stringify({
                "surveyId": this.id,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examQuestionAccuracy}?${data}`,
                method: "POST",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.examTitle = that.$functions.htmlFormat(res.resultBody.title)
                        that.questionData = res.resultBody.questionList
                        if (that.questionData.length > 0) {
                            let index = 0
                            that.questionData.forEach((info) => {
                                info.questionsName = that.$functions.htmlFormat(info.questionsName)
                                if (info.optionList.length > 0) {
                                    info.optionList.forEach((val) => {
                                        val.labelName = that.$functions.htmlFormat(val.labelName)
                                    })
                                }
                                if(that.examQuestionTypeArr.indexOf(parseInt(info.questionsTypeId)) != -1){
                                    that.$set(info, 'index', index++)
                                }
                                if(info.accuracyRate) {
                                    info.accuracyRate = Math.floor(info.accuracyRate * 100)
                                }
                                if ((info.questionsTypeId == 100 
                                    || info.questionsTypeId == 101 
                                    || info.questionsTypeId == 102) 
                                    && info.optionList.length > 0
                                ){
                                    info.optionList.forEach((item) => {
                                        item.proportion = Math.floor(item.proportion * 100)
                                    })
                                }
                            })
                            
                        }
                    }
                },
            };
            this.$util.request(params);
        },
        getInfoData(){
            let that = this
            let data = {
                pageNum: this.pageIndex,
                pageSize: this.pageSize,
                qid: this.qidActive,
                searchValue: this.searchValue,
                surveyId: this.id,
                questionsTypeId: this.questionsTypeId,
                haveInput: this.haveInputActive
            }
            if (this.oidActive) {
                data.oid = this.oidActive
            }
            let params = {
                that: this,
                url: `${this.$config.service.examFindQuestionAnswerInfo}`,
                method: "POST",
                data: data,
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        that.infoList = res.resultBody
                    }
                },
            };
            this.$util.request(params);
        },
        toInfo(item, index) {
            console.log(item)
            this.pageIndex = 1
            this.title = `第${index + 1}题：${item.questionsName}`
            this.qidActive = item.qid
            this.questionsTypeId = item.questionsTypeId
            this.getInfoData()
            this.dialogVisibleInfo = true
        },
        beforeCloseInfo(done) {
            this.oidActive = ''
            this.haveInputActive = false
            this.infoList = []
            this.searchValue = ''
            done()
            console.log(this.oidActive)
        },
        toOptionInfo(item, info, index) { // 多项填空的详情
            // console.log(item)
            // console.log(info)
            this.pageIndex = 1
            this.title = `第${index + 1}题：${item.questionsName}`
            this.oidActive = info.oid
            this.qidActive = item.qid
            this.questionsTypeId = item.questionsTypeId
            if (item.questionsTypeId == 100 || item.questionsTypeId == 101 || item.questionsTypeId == 102){
                this.haveInputActive = info.haveInput
            }else {
                this.haveInputActive = false
            }
            this.getInfoData()
            this.dialogVisibleInfo = true
        },
        pageChange(e) {
            this.pageIndex = e
            this.getInfoData()
        },
        viewAnswerSheet(row) {
            console.log(row)
            this.$router.push({
                name: 'UserExamPreview',
                params: {
                    id: this.id,
                    userId: row.underwayId,
                    findResultParse: 1,
                    showGradeBill: 1,
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.content{
    margin:20px 20px 20px 100px;
    .box-card{
        padding: 20px 10%;
        background-color: #fff;
        border: 1px solid #EBEEF5;
        .left,.right{
            opacity: 0;
        }
        .center{
            .question-title{
                text-align: center;
                font-size: 20px;
                font-weight: bold;    
                padding: 20px;
                margin-bottom: 20px;
            }
            .question-list{
                .question{
                    font-size: 16px;
                    padding-bottom: 30px;
                    .title{
                        padding-bottom: 17px;
                    }
                    .ques-type{
                        color: #CDCDCD;
                    }
                    .option-box{
                        padding-bottom: 15px;
                        .option{
                            font-size: 15px;
                            padding-top: 6px;
                        }
                    }
                    .accuracy-box+.el-table{
                        margin-top: 17px;
                    }
                    .accuracy-box{
                        display: flex;
                        align-items: center;
                        .accuracy{
                            font-size: 15px;
                            color: #2CCE73;
                            margin-right: 30px;
                            .tips{
                                display: inline-block;
                                margin-left: 30px;
                            }
                        }
                        
                    }
                    .is-answer{
                        color: #efa031;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
/deep/.el-table__cell .el-button{
    padding: 0;
}
.page{
    margin-top: 20px;
    text-align: right;
}
.search-box{
    padding-bottom: 20px;
    width: 30%;
}
</style>